import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import { Button, Notification } from '@telus-uds/components-web';
import Close from '@telus-uds/palette-allium/build/web/icons/Close';

import request from '../../../../../../../utils/request';
import TypeAhead from '../../../../../../../orderDetails/components/typeAhead';
import { useLocalizedStringsContext } from '../../../../../../../context/LocalizedStringsContext';

const AddAssignee = ({ orderData, userRights }) => {
  const { canAssignOrder } = userRights;
  const {
    iotOrderDetailsSection: {
      labelUnassigned,
      placeholderSelectAssignee,
      messageAssigneeUpdated
    },
    ORDERS: { assign }
  } = useLocalizedStringsContext();

  const [assigneeList, setAssigneesList] = useState();
  const [assignedUser, setAssignedUser] = useState();
  const [changeAssignee, setChangeAssignee] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const updateAssignee = async value => {
    try {
      setChangeAssignee(false);
      setUpdating(true);
      const userId = _.get(value, '0.id', '');
      const orderId = _.get(orderData, 'id', '');
      const result = await request.put(`/orders/${orderId}`, {
        assignedUserId: userId
      });
      if (result) {
        setUpdating(false);
        setAssignedUser(value[0].label);
        setShowSuccess(true);
      }
    } catch (error) {
      setShowSuccess(false);
      setUpdating(false);
    }
  };

  useEffect(() => {
    const getAssignees = async () => {
      const result = await request.get('/sovAgentAndAdminUsers');
      const user = _.get(orderData, 'orderAssignedTo', '');
      if (result) {
        const transformedResult = _.get(result, 'data', []).map(item => ({
          label: item.name,
          id: item.id
        }));

        if (user) {
          setAssignedUser(`${user.first_name} ${user.last_name}`);
        }
        setAssigneesList(transformedResult);
      }
    };
    getAssignees();
  }, []);

  return (
    <div style={{ padding: '0 0.75rem' }}>
      {updating ? (
        <p>Updating...</p>
      ) : (
        <>
          {changeAssignee ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <TypeAhead
                label=""
                placeholder={placeholderSelectAssignee}
                options={assigneeList}
                onChange={value => updateAssignee(value)}
              />
              <Button
                icon={Close}
                onPress={() => setChangeAssignee(false)}
                accessibilityLabel="Close"
                variant={{ text: true }}
              />
            </div>
          ) : (
            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  gap: '1.2rem'
                }}
              >
                <p>{assignedUser || labelUnassigned}</p>
                {canAssignOrder && (
                  <Button variant={{ text: true }} onPress={() => setChangeAssignee(true)}>
                    {assign}
                  </Button>
                )}
              </div>
              {showSuccess && (
                <Notification
                  variant={{ style: 'success' }}
                  dismissible
                  onExit={() => setShowSuccess(false)}
                  copy="en"
                >
                  {messageAssigneeUpdated.replace('{assignee}', assignedUser)}
                </Notification>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

AddAssignee.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  userRights: PropTypes.objectOf(PropTypes.object).isRequired
};

export default AddAssignee;
